export const SIGNATURE_LABELS = {
    created: "En attente de signature", sent: "En attente de signature", pending: "En attente de signature",
    delivered: "Document reçu", completed: "Signé", signed: "Signé", declined: "Signature refusée",
    voided: "Signature annulée", expired: "Signature expirée",
};
export const PAYMENT_LABELS = {
    unpaid: "À payer", not_paid: "Non payé", awaiting_payment: "En attente de règlement", pending: "Confirmation en cours", requires_review: "Vérification nécessaire",
    paid: "Payé", failed: "Paiement non abouti", expired: "Session expirée", canceled: "Paiement interrompu", cancelled: "Paiement interrompu",
};
export const SCAN_LABELS = {
    not_started: "Non commencé", pending_creation: "Initialisation du scan", awaiting_payment: "En attente de règlement", blocked: "Vérification nécessaire",
    pending: "Scan en attente", queued: "Scan en file d’attente", running: "Scan en cours", completed: "Terminé", failed: "Scan en erreur",
};
